import { useLingui } from "@lingui/react/macro";
import z from "zod";

function normalizeForComparison(value: string): string {
  return value.trim().toLowerCase();
}

export function useSignupFormSchema({
  requireTurnstile = true,
}: { requireTurnstile?: boolean } = {}) {
  const { t } = useLingui();

  return z
    .object({
      firstName: z.string().min(1, {
        error: t`Vänligen ange ditt förnamn`,
      }),
      lastName: z.string().min(1, {
        error: t`Vänligen ange ditt efternamn`,
      }),
      email: z.email({
        error: t`Vänligen ange din e-postadress`,
      }),
      password: z.string({
        error: t`Vänligen ange ett lösenord`,
      }),
      turnstileToken: requireTurnstile
        ? z.string().min(1, {
            error: t`Identifieringen misslyckades`,
          })
        : z.string().optional(),
    })
    .superRefine((values, ctx) => {
      const normalizedPassword = normalizeForComparison(values.password);
      const normalizedEmail = normalizeForComparison(values.email);
      const normalizedFirstName = normalizeForComparison(values.firstName);
      const normalizedLastName = normalizeForComparison(values.lastName);
      const normalizedFullName = normalizeForComparison(
        `${values.firstName} ${values.lastName}`
      );

      if (
        normalizedPassword === normalizedEmail ||
        normalizedPassword === normalizedFirstName ||
        normalizedPassword === normalizedLastName ||
        normalizedPassword === normalizedFullName
      ) {
        ctx.addIssue({
          code: "custom",
          path: ["password"],
          message: t`Lösenordet får inte matcha ditt namn eller din e-post`,
        });
      }
    });
}
